import en from './en.json';
import sv from './sv.json';

const localeData = { en, sv };

export default localeData;
